import { render } from "./Conversations.vue?vue&type=template&id=230ccd3a&lang=pug"
import script from "./Conversations.vue?vue&type=script&lang=js"
export * from "./Conversations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__